import React, { useEffect, useState } from 'react';
import { offerWindow } from 'helpers/offerWindow';

export type SelectedLeagueEntry = {
  leagueId: number;
  sportId: number;
  /** Country / sidebar group name when picking a nested league. */
  groupLabel?: string | null;
};

export const LeagueContext = React.createContext(null as any);

export default ({ children }: any) => {
  const [leagues, setLeagues] = useState<SelectedLeagueEntry[]>([]);
  const [toTime, setToTime] = useState<Date | null>(null);
  // The offer window (helpers/offerWindow): "today", "tomorrow", a named day.
  const [windowKey, setWindowKey] = useState<string>('all');
  const [fromTime, setFromTime] = useState<Date | null>(null);

  const setOfferWindow = (key: string) => {
    const w = offerWindow(key);
    setWindowKey(key);
    setFromTime(w.from ?? null);
    setToTime(w.to ?? null);
  };

  useEffect(() => {
    setLeagues([]);
  }, [toTime, fromTime]);

  const selectLeague = (
    leagueId: number,
    sportId: number,
    groupLabel?: string | null
  ) => {
    setLeagues([
      ...leagues,
      { leagueId, sportId, groupLabel: groupLabel ?? null },
    ]);
  };

  const deselectLeague = (leagueId: number) => {
    const arrayCopy = leagues.filter((x) => x.leagueId !== leagueId);
    setLeagues(arrayCopy);
  };

  const deselectLeagues = (leagueIds: number[]) => {
    if (!leagueIds.length) return;
    const drop = new Set(leagueIds);
    setLeagues(leagues.filter((x) => !drop.has(x.leagueId)));
  };

  return (
    <LeagueContext.Provider
      value={{
        leagues,
        toTime,
        fromTime,
        windowKey,
        setOfferWindow,
        selectLeague,
        deselectLeague,
        deselectLeagues,
        setToTime,
      }}
    >
      {children}
    </LeagueContext.Provider>
  );
};
